'use client';

import { useState } from 'react';
import { keepPreviousData } from '@tanstack/query-core';
import { PhoneCall } from 'lucide-react';

import { AdminCallTable } from '@/app/(app)/admin/calls/components/call-table';
import { CallFiltersProvider, useCallFiltersCtx } from '@/app/(app)/calls/components/provider';
import { PageMain } from '@/app/(app)/page-main';
import { PaginationWithEllipses } from '@/components/pagination';
import { useApiV1Ctx } from '@/components/providers/v1-api';
import { Skeleton } from '@/components/ui/skeleton';

export function AdminCallsPage() {
  return (
    <CallFiltersProvider>
      <CallHistory />
    </CallFiltersProvider>
  );
}

function CallHistory() {
  const { api } = useApiV1Ctx();
  const { filters, setFilters } = useCallFiltersCtx();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);

  const { data, isLoading } = api.calls.searchCallsSearchGet.useQuery(
    {
      query: {
        office_id: filters.officeId,
        intents: filters.intents,
        outcomes: filters.outcomes,
        human_requested: filters.human_requested,
        page,
      },
    },
    {
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    }
  );

  const totalCount = data?.pagination.total || 0;
  const totalPages = Math.ceil(totalCount / pageSize);

  if (!data) {
    if (isLoading) {
      return (
        <PageMain title='Call History'>
          <Skeleton className='h-[80dvh] w-full' />
        </PageMain>
      );
    }

    return (
      <PageMain title='Call History'>
        <div className='flex h-32 w-full flex-col items-center justify-center gap-3'>
          <PhoneCall className='size-10 text-muted-foreground' />
          <div className='text-muted-foreground'>You don&apos;t have any calls yet.</div>
        </div>
      </PageMain>
    );
  }

  return (
    <PageMain title='Call History'>
      <div className='space-y-2'>
        <AdminCallTable data={data?.calls || []} isLoading={isLoading} />

        <PaginationWithEllipses className='mt-4' currentPage={page} totalPages={totalPages} onPageChange={setPage} />
      </div>
    </PageMain>
  );
}
